import { STORE_ID, TYPES } from "./types"

const INITIAL_STATE = {
    item: {
        descricao: "",
        bancoId: "0",
        responsavelPorAcao: "0",
        codigoConsistencia: "",
        id: ""
    },
    copy: {},
    invalid: {
        descricao: false,
        responsavelPorAcao: false,
        codigoConsistencia: false,
        bancoId: false
    },
    items: [],
    bancos: [],
    responsaveis: [],
    activeTab: "Search",
    seeRegister: false,
    permitions: {
        criar: false,
        deletar: false,
    }
}

export default function inconsistencias(state = INITIAL_STATE, action) {
    switch (action.storeId) {
        case STORE_ID:
            switch (action.type) {
                case TYPES.SET_PERMITIONS:
                    return { ...state, permitions: action.value }
                case TYPES.INCONSISTENCIAS:
                    return { ...state, items: action.value }
                case TYPES.SET_BANCOS:
                    return { ...state, bancos: action.value }
                case TYPES.SET_RESPONSAVEIS:
                    return { ...state, responsaveis: action.value }
                case TYPES.INCONSISTENCIA:
                    return { ...state, item: action.value }
                case TYPES.INVALID_INCONSISTENCIA:
                    return { ...state, invalid: { ...state.invalid, [action.field]: true } }
                case TYPES.CLEAN_INVALID_INCONSISTENCIA:
                    return { ...state, invalid: { ...state.invalid, [action.field]: false } }
                case TYPES.INCONSISTENCIA_COPY:
                    return { ...state, copy: action.value }
                case TYPES.CLEAN_REGISTER:
                    return { ...state, item: INITIAL_STATE.item, invalid: INITIAL_STATE.invalid }
                case TYPES.SET_ACTIVE_TAB:
                    return { ...state, activeTab: action.value }
                case TYPES.SET_SEE:
                    return { ...state, seeRegister: action.value }
                default:
                    return { ...state }
            }
        default:
            return { ...state }
    }
}